// extracted by mini-css-extract-plugin
module.exports = {"PopupWrapper":"_2ZdSZ","hidden":"jmx1j","Popup":"_2t61u","content":"_3OLts","PopupFooter":"_31d7k"};